import SimplyCarousel from './SimplyCarousel';

export default SimplyCarousel;